// removed by extract-text-webpack-plugin
module.exports = {"container":"ErrorPage-module__container___1gQmK","title":"ErrorPage-module__title___AQWxW","sub-title":"ErrorPage-module__sub-title___2aMx4","mobile":"ErrorPage-module__mobile___v0ZL4"};


//////////////////
// WEBPACK FOOTER
// ./src/js/components/ErrorPage/ErrorPage.module.scss
// module id = 196
// module chunks = 0 1